import styled from "styled-components";

const SubmitButton = styled.button`
  padding: 15px 30px;
  border: none;
  background-color: #87ceeb;
  color: #fff;
  font-weight: 500;
  font-size: 20px;
  border-radius: 50px;
  cursor: pointer;
  transition: 0.2s ease-in-out;
  margin-top: 80px;
  width: 50%;
  align-self: center;

  &:hover {
    background-color: #1e90ff;
  }
`;

export default SubmitButton;
